import script from "./VVVDashboardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVDashboardNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVDashboardNew.vue?vue&type=style&index=0&id=2b48f81f&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b48f81f"]])

export default __exports__